import { Entity, Property as IgnitionProperty } from '@square/ignition';
import { ApiReferenceFieldType } from '@squareup/dex-ui-shared-api-reference';
import React, { FunctionComponent } from 'react';

interface PropertyTypeProps {
  property: IgnitionProperty;
  entityStack?: Entity[];
}

const PropertyType: FunctionComponent<PropertyTypeProps> = ({
  property,
  entityStack = [],
}) => {
  return (
    <ApiReferenceFieldType
      labelName={property.name}
      entity={property.entity}
      itemEntity={property.itemEntity}
      isEntity={property.isEntity}
      isRequest={property.isRequest}
      isEnum={property.isEnum}
      isArray={property.isArray}
      isMap={property.isMap}
      hasEntity={property.containsEntity}
      hasEnum={property.containsEnum}
      type={property.type}
      itemType={property.itemType}
      format={property.format}
      entityStack={entityStack}
    />
  );
};

export { PropertyType };
